import * as Types from '../actions/types';
import * as Actions from '../actions/action';

let initialState = {
  shouldRefresh: Actions.SHOULD_REFRESH_INIT_VALUE,
  states: [],
  logoCacheBuster: Math.random().toString(36).substring(7)
};

export default function whiteLabelingReducer(state = initialState, action) {
  switch (action.type) {
    case Types.UPLOAD_LOGO_SUCCESS:
      return {
        ...state,
        shouldRefresh: !state.shouldRefresh,
        logoCacheBuster: Math.random().toString(36).substring(7)
      };
    case Types.DELETION_SUCCESS:
      return {
        ...state,
        shouldRefresh: !state.shouldRefresh,
        logoCacheBuster: Math.random().toString(36).substring(7)
      };
    default:
      return state;
  }
}
